import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useGetOpeningModelGameApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  return useMutation({
    mutationFn: async (payload: {model_game_id: string | number}) => {
      const response = await ChessRestClient.get(
        'assessment/v1/learning/get_opening_model_game/',
        {params: {model_game_id: payload.model_game_id}},
      );
      return response.data;
    },
    onSuccess: data => {
      if (data?.success) {
        handleOnSuccess?.(data);
      } else {
        handleOnError?.(data);
      }
    },
    onError: err => handleOnError?.(err),
  });
}

